import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { simpleDeepClone } from '@phx-erp/shared';
import { DisableFormDirective } from '../../../../../@core/directives/disable-form.directive';
import { AddressDropDownComponent } from '../../../../crm/modules/company-drop-down/company-drop-down/address-drop-down.component';
import { EditLinks } from '../../../../../@core/constants/edit-links';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { Address, Document, DocumentDirection, PostalAddress } from '../../../../../generated/generated-types';
import { AddressService } from '../../../../crm/services/address.service';
import { WidgetEditGenericDocumentComponent } from '../../widget-edit-generic-document/widget-edit-generic-document.component';
import { documentInvoiceReceiverAddressFallbackFields } from './fallback-fields';

@Component({
  selector: 'app-formly-invoice-receiver-address-widget',
  templateUrl: './formly-invoice-receiver-address-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DisableFormDirective,
    FormlyModule,
    ReactiveFormsModule,
    FormsModule,
    AddressDropDownComponent,
    TranslatePipe,
  ]
})
export class FormlyInvoiceReceiverAddressWidgetComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private i18nService: I18nService,
    private addressService: AddressService,
    private cdRef: ChangeDetectorRef) {
    super();
  }

  subForm = new FormGroup({});
  fallbackFields: any[];

  newModel: PostalAddress = {} as any;

  ngAfterViewInit(): void {
    this.field.props.icon = "fa-solid fa-address-book";
    this.fallbackFields = documentInvoiceReceiverAddressFallbackFields();
    //TODO load fields from server, we can extends our base class to fieldtype

    //this will be triggered by the fallback form and update the formControl
    this.subForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {

      let errors: ValidationErrors = Object.keys(this.subForm.controls).reduce((acc, key) => {
        const control = this.subForm.controls[key];
        if (control.errors) {
          const errorKey = Object.keys(control.errors)[0];
          acc[errorKey] = control.errors[errorKey];
        }
        return acc;
      }, {});

      //pass change up to parent
      this.formControl.setValue(this.newModel);
      if (Object.keys(errors).length > 0)
        this.formControl.setErrors(errors);


      // if (this.model.status === DocumentStatusType.CO || this.model.status === DocumentStatusType.RE) {
      //   this.subForm.disable();
      // }
    });



    //this will be triggered by the parent formControl and update the fallback form
    this.formControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
      // console.log('form1.valueChanges', x);
      this.newModel = x;
      this.cdRef.detectChanges();
    });

    if (this.formControl.value)
      this.newModel = simpleDeepClone(this.formControl.value);

    this.cdRef.detectChanges();
  }

  async selectedAddressChanged(address: Address | Address[]) {

    if (Array.isArray(address)) {
      address = address[address.length - 1];
    }

    // if (!newAddress)
    //   return; //clear?

    if (this.options.formState?.detailComponent) {
      let widget = this.options.formState.detailComponent as WidgetEditGenericDocumentComponent;
      await widget.invoiceReceiverAddressChanged(address);
    }
    this.cdRef.detectChanges();
  }

  getDetailUrl(address: Address) {
    return EditLinks.ADDRESS + address.id;
  }



  showCreditor() {  //takes about 200ms to load documentDefinition

    if (!(this.model as Document)?.documentDefinition?.documentDirection) {
      return false;
    }
    let showCreditor = !((this.model as Document)?.documentDefinition?.documentDirection == DocumentDirection.OUT);
    return showCreditor;

  }

  showDebitor() {

    if (!(this.model as Document)?.documentDefinition?.documentDirection) {
      return false;
    }
    let showDebitor = !((this.model as Document).documentDefinition?.documentDirection == DocumentDirection.IN);
    return showDebitor;

  }


}
